// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {getAuth, initUser} from './config/auth'
import vueTap from 'v-tap';
// import VueLocalStorage from 'vue-localstorage';
import vueToast from './components/toast';
import vuePop from './components/pop';
import './scss/layout/home.scss'
import VueCookies from 'vue-cookies'


Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(vueTap);
// Vue.use(VueLocalStorage);
Vue.use(vueToast);
Vue.use(vuePop);


initUser();


router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        if (getAuth()) {  // 通过cookie获取当前的auth是否存在
            next();
        }
        else {
            next({
                path: '/login',
                query: {url: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        next();
    }
})

new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js